var gql = require("@apollo/client").gql;

const SEARCH_NEIGHBOURS_QUERY = gql`
    query SEARCH_NEIGHBOURS_QUERY($id: Int!) {
        neighbours(id: $id, with_tariffs: 1) {
            data {
                id
                full
            }
        }
    }
`;
module.exports = SEARCH_NEIGHBOURS_QUERY;
